import React, {  createContext, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import jwtDecode from 'jwt-decode';
import * as ActionsAuth from '~/store/modules/auth/actions';
import { config } from '~/config';
import { apiLucree } from '~/services/api';




export const TokenContext = createContext([]);

export function TokenProvider(props) {
	const { children } = props;
	const { authv1 } = useSelector((state) => state.auth);
	const dispatch = useDispatch();
	const [loadingToken, setLoadingToken] = useState(true);

	async function authToken() {
		try {
			const credentials = {
				username: config.USER_AUTHENTICATION_DEV,
				password: config.USER_AUTHENTICATION_PASS_DEV,
			};
			const response = await apiLucree.post(
				'autenticacao/v1/',
				credentials
			);

			return response;
		} catch (error) {
			toast.error(
				'Os dados de autenticação de token não foram carregados. Por favor atualize a página'
			);
		}

		return null;
	}

	async function autenticacaoV1Token() {
		if(authv1.expires){
			
			const expiresIn10Min = authv1.expires * 1000 - Date.now() <= 10 * 60 * 1000;
			if(expiresIn10Min){
				try {
					
					const credentials = {
						username: config.USER_AUTHENTICATION_DEV,
						password: config.USER_AUTHENTICATION_PASS_DEV,
					};
					const response = await apiLucree.post(
						'autenticacao/v1/',
						credentials
					);
					
					if(response.data.id_token){
						
						dispatch(ActionsAuth.successTokenV1({
							token: response.data.id_token,
							expires: jwtDecode(response.data.id_token).exp
						}));
					}else{
						
						dispatch(ActionsAuth.failedTokenV1("erro"));
					}

					return response;
				} catch (error) {
					
					toast.error(
						'Os dados de autenticação de token não foram carregados. Por favor atualize a página'
					);
				}
			} else {
				
				const info = {
					data: {
						id_token: authv1.token
					}
				}
	
				return info;
			}
		}else{
			try {
				
				const credentials = {
					username: config.USER_AUTHENTICATION_DEV,
					password: config.USER_AUTHENTICATION_PASS_DEV,
				};
				const response = await apiLucree.post(
					'autenticacao/v1/',
					credentials
				);
				
				if(response.data.id_token){
					dispatch(ActionsAuth.successTokenV1({
						token: response.data.id_token,
						expires: jwtDecode(response.data.id_token).exp
					}));
				}else{
					dispatch(ActionsAuth.failedTokenV1("erro"));
				}
	
				return response;
			} catch (error) {
				
				toast.error(
					'Os dados de autenticação de token não foram carregados. Por favor atualize a página'
				);
			}
		}

		return null;
	}

	async function callVerifyDoc(doc) {
		try {
			return await apiLucree.post(`authentication/api/verifica-documento/`, {
				documento: doc,
				headers: {
					'Content-Type': 'application/json',
				},
			}).then((res) => {
				setLoadingToken(false);
				return res;
			});
		} catch (error) {
			setLoadingToken(false);
			return error.response;
		}
	}

	async function getCodeByType(doc, type) {
		try {
			return await apiLucree.post(`authentication/api/solicita-envio-codigo-totp/`, {
				documento: doc,
				metodo_envio_totp_code: type,
				headers: {
					'Content-Type': 'application/json',
				},
			}).then((res) => {
				setLoadingToken(false);
				return res;
			});
		} catch (error) {
			toast.error('Ocorreu um erro. Tente novamente.')
			setLoadingToken(false);
			return error.response;
		}
	}

	async function callVerifyCode(doc, code) {
		try {
			return await apiLucree.post(`authentication/api/verifica-codigo-totp/`, {
				documento: doc,
				codigo_totp: code,
				headers: {
					'Content-Type': 'application/json',
				},
			}).then((res) => {
				setLoadingToken(false);
				return res;
			});
		} catch (error) {
			toast.error('Ocorreu um erro. Tente novamente.')
			setLoadingToken(false);
			return error.response;
		}
	}



	return (
		<TokenContext.Provider
			value={{
				authToken,
				autenticacaoV1Token,
				loadingToken,
				setLoadingToken,
				callVerifyDoc,
				getCodeByType,
				callVerifyCode,
			}}>
			{children}
		</TokenContext.Provider>
	);
}
